import { content } from '../data/content';
import { SectionHeading } from './ui/Ui';

/**
 * زاوية الأمان — الاعتراض الصامت الأكبر في أي جهاز حراري داخل البيت.
 *
 * الخلفية فاتحة ممتدة بعرض الصفحة كاملاً (لا صندوق مدوّر داخل الصفحة):
 * الأخضر لونٌ داكن، فتباينه فوق الكحلي ضعيف ويتعب العين، بينما يقرأ بوضوح
 * تام فوق الفاتح. غيّرنا الخلفية بدل أن نغيّر لون الأمان.
 */
export default function Safety() {
  return (
    <section id="safety" className="scroll-mt-16 md:scroll-mt-20 py-10 md:py-20 bg-z-light">
      <div className="container mx-auto">
        <SectionHeading
          eyebrow={content.safetyEyebrow}
          icon="fa-shield-halved"
          iconColor="text-z-green"
          title={content.safetyTitle}
          subtitle={content.safetySubtitle}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
          {content.safetyItems.map((item) => (
            <div key={item.title} className="bg-white rounded-3xl p-6 md:p-8 border border-gray-200 flex gap-4 md:gap-5 items-start">
              <div className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-full bg-z-green/10 text-z-green flex items-center justify-center text-xl md:text-2xl">
                <i className={`fa-solid ${item.icon}`} />
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-bold mb-2 text-z-navy">{item.title}</h3>
                <p className="text-z-gray text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
